function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M10 14.6c0-.9.9-4.5-3.7-4.5-4.5 0-2.7 4.5-3.6 4.5H0v-4.5C0 8.2 2.7 1 3.6 1h21.7c1.8 1.8 7.3 8.1 8.2 9v4.6h-1.8c0-.9 0-4.5-3.7-4.5-3.6 0-3.6 2.7-3.6 4.5H10zM22.5 2.8v3.6H28l-3.6-3.6h-1.8z"
}), React.createElement("path", {
  d: "M6.5 16.9a3 3 0 0 1-3-3 3 3 0 0 1 3-3 3 3 0 0 1 3 3 3 3 0 0 1-3 3zm0-.8c1.2 0 2.2-1 2.2-2.2 0-1.3-1-2.3-2.2-2.3-1.2 0-2.2 1-2.2 2.3 0 1.2 1 2.2 2.2 2.2zM28.2 16.8a3 3 0 0 1-3-3 3 3 0 0 1 3-2.9 3 3 0 0 1 3 3 3 3 0 0 1-3 3zm0-.8c1.2 0 2.2-1 2.2-2.1 0-1.2-1-2.2-2.2-2.2-1.2 0-2.1 1-2.1 2.2 0 1.2 1 2.1 2.1 2.1z"
}));

var SvgVehicleVan = function SvgVehicleVan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 17,
    viewBox: "0 0 34 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleVan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-van.e58e1a5a.svg";
export { ForwardRef as ReactComponent };